export enum AdminRole {
  TECHNICAL = 'technical',
  MARKETING = 'marketing',
}
